import React, { useState } from "react";
import { Popup } from "./Popup.js";
import { Button } from "../components/Button.js";
export const PopupButton = ({ filloutId, domain, inheritParameters, parameters, width, height, onInit, onPageChange, onSubmit, text, color, size, float, }) => {
    const [isOpen, setIsOpen] = useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { onClick: () => setIsOpen(true), text: text, color: color, size: size, float: float }),
        isOpen && (React.createElement(Popup, { filloutId: filloutId, domain: domain, inheritParameters: inheritParameters, parameters: parameters, onClose: () => setIsOpen(false), onInit: onInit, onPageChange: onPageChange, onSubmit: onSubmit, width: width, height: height }))));
};
